import { ChevronRightIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { memo, useCallback, useRef, useState } from 'react';
import { HeroIcon } from '../../types';

interface ContextMenuSubmenuProps {
  icon: HeroIcon | React.FC<React.SVGProps<SVGSVGElement>>;
  label: React.ReactNode;
  children: React.ReactNode;
}

const HOVER_DELAY = 75;

const ContextMenuSubmenu_: React.FC<ContextMenuSubmenuProps> = ({ icon: Icon, label, children }) => {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const onMouseEnter = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => setOpen(false), HOVER_DELAY);
  }, []);

  return (
    <div className="relative" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className={classNames('flex w-full items-center rounded-md px-2 py-2 text-sm border border-transparent cursor-pointer select-none', 'hover:bg-neon-green-300 dark:hover:bg-black group')} onClick={(e) => e.stopPropagation()}>
        <Icon className="w-5 h-5 mr-2 group-hover:text-dark-green-800 dark:group-hover:text-neon-green-300 flex-shrink-0" />
        <span className="flex-grow">{label}</span>
        <ChevronRightIcon className="w-4 h-4 ml-auto flex-shrink-0" />
      </div>
      {open && <div className="absolute left-full top-0 ml-1 z-50 bg-white dark:bg-[#242424] p-2 rounded-md flex flex-col w-48 border border-gray-300 shadow-sm max-h-64 overflow-y-auto">{children}</div>}
    </div>
  );
};

export const ContextMenuSubmenu = memo(ContextMenuSubmenu_);
